<template>
    <div class="row">
        <div class="col-1" style="padding-top: 8px; padding-left: 12px; padding-right: 5px">
            <div
                class="container-butacas animated fadeInLeft text-align-center"
            >
                <div
                    v-for="(butacas, fila) in filas"
                    :key="fila"
                    class="butaca filav"
                >
                    <strong>
                        <span class="font-weight-bold">{{ fila }}</span>
                    </strong>
                </div>
            </div>
        </div>
        <div class="col-11">
            <div
                class="margin-responsive container-butacas-wrapper scroll-smooth mb-2 p-2"
                v-if="!loading"
                ref="butacasWrapper"
            >
                <div
                    :class="'container-butacas animated fadeInLeft text-align-' + print_align"
                >
                    <template v-for="(butacas, fila) in filas">
                        <span :key="fila">
                            <template v-for="(asiento, index) in butacas">
                                <AsientoComponent
                                    :asiento="asiento"
                                    :fila="fila"
                                    :front="front"
                                    :key="index + '_2'"
                                    @toggle="() => $emit('butacaSeleccionada', fila, asiento?.asiento)"
                                />
                            </template>

                            <br />
                        </span>
                    </template>
                </div>
            </div>
            <template v-else>
                <LoaderComponent/>
            </template>
        </div>
        <div class="mb-3 text-right col-12">
            <Button
                class="rounded-0 button small-button mr-1"
                icon="fa fa-arrow-left"
                @click="scrollLeft()"
            />
            <Button
                class="rounded-0 button small-button"
                icon="fa fa-arrow-right"
                @click="scrollRight()"
            />
        </div>
    </div>
</template>

<script>
    import AsientoComponent from '@/components/backend/stepper/components/AsientoComponent'

    export default {
        props: {
            loading: {
                type: Boolean,
                required: true,
            },
            filas: {
                required: true
            },
            print_align: {
                required: true,
                type: String
            },
            front: {
                required: false,
                type: Boolean,
                default: false
            }
        },
        methods: {
            scrollLeft() {
                this.$refs['butacasWrapper'].scrollBy(-this.$refs['butacasWrapper'].parentElement.scrollWidth, 0)
            },
            scrollRight() {
                this.$refs['butacasWrapper'].scrollBy(this.$refs['butacasWrapper'].parentElement.scrollWidth, 0)
            },
        },
        components: {
            AsientoComponent
        }
    }
</script>